// constants.ts

export const NAME = 'contentEditor';